import { renderSite } from "ccui-framework";
import { combineReducers } from "../../../src/reducers/combineReducers";
import { configModule } from "./config";
import layoutSelector from "../../../src/layouts/selector";

const config = configModule();

renderSite(config, combineReducers, layoutSelector(config));
